export default [
  {
    path: '/account',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Profil',
        component: () => import('./containers/CurrentUserContainer'),
      },
    ],
  },
  {
    path: '/users',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'UserList',
        component: () => import('./containers/UserListContainer'),
        children: [
          {
            path: 'create',
            name: 'UserCreate',
            component: () => import('./containers/UserCreateContainer'),
          },
          {
            path: 'restore',
            name: 'UserRestore',
            component: () => import('./containers/UserRestoreContainer'),
          },
          {
            path: ':userId',
            name: 'UserUpdate',
            props: true,
            component: () => import('./containers/UserUpdateContainer'),
          },
        ],
      },
    ],
  },
]
